module.exports = __webpack_public_path__ + "assets/img/PhoneOEM.a73f85aa.png";